import React from "react";

import moment from "moment";

import { SPEC_FLAGS_MAP } from "../../../../../Common/constants/SpecFlagConstants";
import LockedValue from "../../../../../grace-period/components/LockedValue";
import { useAccessStatus } from "../../../../../grace-period/hooks/useAccessStatus";
import { isResultRevealingSpec } from "../../../../../grace-period/utils";
import ReportViewImage from "./ReportViewImage";

import { ReactComponent as StatusDotIcon } from "../../../../../../assets/images/environment/statusPingDot.svg";

export default function ReportViewTitle({
  pin,
  imagePath,
  curReportInfo,
  setImagePath,
}) {
  const { areResultsLocked } = useAccessStatus();
  const {
    color, label, box_shadow_color,
  } = SPEC_FLAGS_MAP[pin.specs_flag] ?? SPEC_FLAGS_MAP.invalid;
  const lockStatus = areResultsLocked && isResultRevealingSpec(pin.specs_flag);

  return (
    <div className="env-analytics-report-view-section-title-container">
      <ReportViewImage
        imagePath={imagePath}
        locationID={pin.location_id}
        curReportInfo={curReportInfo}
        setImagePath={setImagePath}
      />
      <div className="env-analytics-report-view-section-title-info">
        <span className="env-analytics-report-view-section-title-info-header-title">
          {pin.swab_number}
        </span>
        <span className="env-analytics-report-view-section-title-info-header-date">
          {moment(pin.added_on).format("DD MMMM YYYY")}
        </span>
        <div className="env-analytics-report-view-section-title-info-header-status" style={lockStatus ? undefined : { backgroundColor: box_shadow_color }}>
          {lockStatus ? (
            <LockedValue locked />
          ) : (
            <>
              <StatusDotIcon width={25} height={25} fill={color} />
              <span style={{ color }}>
                {label}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
